import React from "react";

const Avatar = ({x, y, size = 1, color}) => (
  <g transform={`translate(${x} ${y}) scale(${size})`}>
    <circle r={20} fill={color} stroke="#2B3A55" strokeWidth={2.5}/>
    <circle cy={-4} r={7} fill="#fff" stroke="#2B3A55" strokeWidth={2}/>
    <path d="M-11 13a11 9 0 0 1 22 0" fill="#fff" stroke="#2B3A55" strokeWidth={2}/>
  </g>
);

export default Avatar;
